import { Button, Divider, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { MenuPopover, MenuPopoverItem } from 'src/components/minimals';
import { ACCESS_ROLES } from 'src/config';
import { useThemeType } from 'src/contexts/themeTypeContext/theme-type-context';
import { useAuthentication } from 'src/features/authentication/context';
import { IconWrapper, Overlay } from 'src/layouts/header/style';
import featureFlags from '../../../feature-flags.json';
import { Link } from 'react-router-dom';
import { useHtmlElement } from 'src/hooks/useHtmlElement';
import { useToggle } from 'src/hooks/useToggle';
import { useResponsive } from 'src/hooks/useResponsive';
import { UserIcon } from 'src/assets/icons/UserIcon';

const UserAction = () => {
  const theme = useTheme();
  const { user, logout, getCurrentRole, customerId } = useAuthentication();
  const greyColor = theme.palette.grey[700];
  const greyLightColor = theme.palette.grey[300];
  const { htmlElement, addHtmlElement, removeHtmlElement } = useHtmlElement();
  const { state, onToggle } = useToggle();
  const textDisabledColor = theme.palette.text.disabled;

  const handleMenuOpen = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    addHtmlElement(event.currentTarget);
    onToggle();
  };
  const handleMenuClose = () => {
    removeHtmlElement();
    onToggle();
  };
  const { themeType, toggleThemeType } = useThemeType();
  const isMobile = useResponsive('down', 'md');
  const isSuperAdmin = getCurrentRole(null, null) === ACCESS_ROLES.SUPER_ADMIN;
  return (
    <>
      <IconWrapper
        style={isMobile ? { top: '3px' } : {}}
        onClick={(event) => handleMenuOpen(event)}
        data-sm={'profile-icon'}
      >
        <Overlay active={state.toString()} />
        <UserIcon
          width={isMobile ? 28 : undefined}
          height={isMobile ? 28 : undefined}
          fill={greyColor}
          outline={greyLightColor}
        />
      </IconWrapper>
      <MenuPopover open={htmlElement} onClose={handleMenuClose} arrow="top-right">
        <MenuPopoverItem
          sx={{ px: '20px!important', py: '8px!important' }}
          customContent={
            <Stack>
              <Typography variant="subtitle1">{user?.firstName + ' ' + user?.lastName}</Typography>
              <Typography variant="body2" color={textDisabledColor}>
                {user?.email}
              </Typography>
            </Stack>
          }
          handleClick={() => {}}
          testId="profile-button"
        />
        {featureFlags.userProfile === 1 && !isSuperAdmin ? (
          <Link to={`/profile?customerId=${customerId.value}`}>
            <MenuPopoverItem
              sx={{ px: '15px!important', py: '6px!important' }}
              customContent={
                <Button
                  sx={{
                    width: '100%',
                    color: theme.palette.common.black,
                    fontSize: '16px',
                    fontWeight: theme.typography.fontWeightRegular,
                    padding: '0',
                    '&:hover': {
                      background: 'none',
                    },
                  }}
                  variant="text"
                  data-sm="add-site-button"
                >
                  Profile
                </Button>
              }
              handleClick={() => {}}
              testId="profile-button-cta"
            />
          </Link>
        ) : null}
        <Divider />
        {featureFlags.themeMode || featureFlags.userIds.includes(user?.userId) ? (
          <MenuPopoverItem
            sx={{ px: '20px!important', py: '8px!important' }}
            customContent={
              <Typography>Switch to {themeType === 'dark' ? 'light mode' : 'dark mode'}</Typography>
            }
            handleClick={() => {
              toggleThemeType();
            }}
            testId="toggle-theme-button"
          />
        ) : null}
        <MenuPopoverItem
          sx={{ px: '20px!important', py: '8px!important' }}
          customContent={<Typography>Logout</Typography>}
          handleClick={logout}
          testId="logout-button"
        />
      </MenuPopover>
    </>
  );
};

export default UserAction;
